import React, { Component } from 'react';
import { Table, DatePicker, Button, Dropdown, Input, message } from 'antd';
import { connect } from 'react-redux';
import _ from 'lodash';
import { logout, getAllUsers, downloadReportDetail, downloadUserData, getResolutionData, downloadResolutionDetail } from '../../user/action/user.actions'
import Header from "../../../layout/DefaultLayout/Header";
import '../../user/component/providerDeshbord.scss'
import { history } from '../../../helpers'
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import TableComponent from '../../user/component/dummyTable';
import moment from 'moment';

export class Resolutions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usersColumns: [
        {
          title: 'User Name',
          dataIndex: 'name',
          key: 'name',
          sorter: true
        },
        {
          title: 'User Code',
          dataIndex: 'user_code',
          key: 'user_code',
          sorter: true
        },
        {
          title: 'Type',
          dataIndex: 'type',
          key: 'type',
          sorter: true
        },
        {
          title: 'Subject',
          dataIndex: 'subject',
          key: 'subject',
          sorter: true
        },
        {
          title: 'Description',
          dataIndex: 'description',
          key: 'description',
          sorter: true
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          sorter: true
        },
        {
          title: 'Created At',
          dataIndex: 'created_at',
          key: 'created_at',
          sorter: true
        }
      ],
      resolution_data: [],
      sortOrder: null,
      sortedColumn: null
    }
    this.logout = this.logout.bind(this);

  }
  componentDidMount() {
    this.getResolutionData();
  }

  logout(e) {
    const { dispatch } = this.props;
    dispatch(logout())
  }

  getResolutionData = () => {
    const { dispatch } = this.props;
    dispatch(getResolutionData()).then((response) => {
      let data = this.initializeDate(response.data)
      data = data.map(e => {
        return {...e, name: e.user_detail.name, user_code: e.user_detail.user_code}
      })
      this.setState({ resolution_data: data, originalData: data })
    })
  }

  initializeDate = (data) => {
    _.map(data, function (record) {
      record['Created_at'] = new Date(record['Created_at Date']).toLocaleString()
    })
    return data
  }

//   downloadReport = () => {
//     const { dispatch } = this.props;
//     var startDateFormat = new Date(this.state.start_date)
//     var startDate = `${startDateFormat.getFullYear()}-${startDateFormat.getMonth() + 1}-${startDateFormat.getDate()}`
//     var endDateFormat = new Date(this.state.end_date)
//     var endDate = `${endDateFormat.getFullYear()}-${endDateFormat.getMonth() + 1}-${endDateFormat.getDate()}`
//     var data = {
//       start_date: startDate,
//       end_date: endDate
//     }
//     dispatch(downloadReportDetail(data)).then((response) => {
//       let data = this.initializeDate(response.data)
//       var dataDownload = data
//       var fileName = "Reports"
//       const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//       const fileExtension = '.xlsx';
//       const ws = XLSX.utils.json_to_sheet(dataDownload);
//       const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
//       const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
//       const dataDetail = new Blob([excelBuffer], { type: fileType });
//       FileSaver.saveAs(dataDetail, fileName + fileExtension);
//     })
//   }

//   downloadUserDetail = () => {
//     const { dispatch } = this.props;
//     var data = {
//       user_type: this.state.user_type
//     }
//     dispatch(downloadUserData(data)).then((response) => {
//       var dataDownload = response.data
//       var fileName = "Reports"
//       const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//       const fileExtension = '.xlsx';
//       const ws = XLSX.utils.json_to_sheet(dataDownload);
//       const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
//       const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
//       const dataDetail = new Blob([excelBuffer], { type: fileType });
//       FileSaver.saveAs(dataDetail, fileName + fileExtension);
//     })
//   }

//   filterUserData = () => {
//     debugger
//     let editData = [...this.state.booking_data]
//     var startDateFormat = new Date(this.state.start_date)
//     var endDateFormat = new Date(this.state.end_date)
//     editData = _.filter(editData, function (o) { return moment(o['Bidding Date']).isBetween(startDateFormat, endDateFormat) });
//     this.setState({ booking_data: editData });
//   }

//   handleDateChange = (name, value) => {
//     if (name == 'start_date') {
//       this.setState({ 'start_date': value });
//     } else {
//       this.setState({ 'end_date': value });
//     }
//   }

  // useEffect(() => {
  //   if (sortOrder) {
  //     let editUserData = [...updatedUserData]
  //     if (sortedColumn) {
  //       // editUserData = editUserData.sort((a, b) => {
  //       //   if (sortOrder === 'asc') {
  //       //     return a[sortedColumn] - b[sortedColumn];
  //       //   } else {
  //       //     return b[sortedColumn] - a[sortedColumn];
  //       //   }
  //       // })
  //       editUserData = _.orderBy(editUserData, [sortedColumn], [sortOrder])

  //     }
  //     setUpdatedUserData(editUserData);
  //   }
  // }, [sortOrder])

 handleSort = (column) => {
  let editResolutionData = [...this.state.resolution_data]
  let order = this.state.sortOrder
  let currentColumn = this.state.sortedColumn
  if (column === currentColumn) {
    // setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    order = order == 'asc' ? 'desc' : 'asc'
  } else {
    currentColumn = column;
    order = 'asc'
    // setSortedColumn(column);
    // setSortOrder('asc');
  }
  editResolutionData = _.orderBy(editResolutionData, [currentColumn], [order])
  this.setState({resolution_data: editResolutionData, sortOrder: order, sortedColumn: currentColumn});
};

handleDateChange = (name, value) => {
  if (name == 'start_date') {
    this.setState({ 'start_date': value });
  } else {
    this.setState({ 'end_date': value });
  }
}

downloadReport = () => {
  if(this.state.start_date && this.state.end_date){
    const { dispatch } = this.props;
    var startDateFormat = new Date(this.state.start_date)
    var startDate = `${startDateFormat.getFullYear()}-${startDateFormat.getMonth() + 1}-${startDateFormat.getDate()}`
    var endDateFormat = new Date(this.state.end_date)
    var endDate = `${endDateFormat.getFullYear()}-${endDateFormat.getMonth() + 1}-${endDateFormat.getDate()}`
    var data = {
      start_date: startDate,
      end_date: endDate
    }
    dispatch(downloadResolutionDetail(data)).then((response) => {
      let data = this.initializeDate(response.data)
      var dataDownload = data
      var fileName = "Reports"
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const fileExtension = '.xlsx';
      const ws = XLSX.utils.json_to_sheet(dataDownload);
      const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const dataDetail = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(dataDetail, fileName + fileExtension);
    })
  }else{
    message.error('Please select the start date and end date');
  }
  
}

filterUserData = () => {
  if(this.state.start_date && this.state.end_date){
    let editData = [...this.state.originalData]
    var startDateFormat = new Date(this.state.start_date)
    var endDateFormat = new Date(this.state.end_date)
    editData = _.filter(editData, function (o) { return moment(new Date(o['created_at'])).isBetween(startDateFormat, endDateFormat) });
    this.setState({ resolution_data: editData });
  }else{
    this.setState({ resolution_data: this.state.originalData });
  }
}

handleSearch = (value) => {
  let updatedUserData = [...this.state.originalData];
  if (value !== "") {
    updatedUserData = updatedUserData.filter((item) =>
      Object.values(item).some((val) =>
        val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    )
  }
  this.setState({resolution_data: updatedUserData})
}

render() {
  const { usersColumns, data, resolution_data } = this.state
  return (
    <div>
      <Header></Header>
      <div className="services-background">
        <div className="biddings-container">
          {/* <div className="service-heading-txt">Users</div> */}
          {/* <div style={{ display: 'flex' }}>
              <select style={{
                height: '20px', fontSize: '15px',
                fontFamily: 'nunito-black',
                padding: '0px 26px',
                cursor: 'pointer',
                height: '35px',
                letterSpacing: '1px',
                margin: '20px 10px 0px 0px',
              }} name="Select" id="userType" onChange={(e) => this.setState({ user_type: e.target.value })}>
                <option value="C">Customer</option>
                <option value="P">Provider</option>
              </select>
              <Button className='btn-added-right' onClick={() => { this.downloadUserDetail() }}>
                Download User Data
              </Button>
            </div> */}

          {/* <TableComponent columnsDetails={usersColumns} dataSource={data} /> */}
          <div className="service-heading-txt">Resolution</div>
          {/* <div className="row">
            <div className="col-3">
              <DatePicker
                className='experience-date-picker-box'
                placeholder="Start Date"
                required
                name="start_date"
                value={this.state.start_date}
                onChange={(e) => { this.handleDateChange('start_date', e) }}
              />
            </div>
            <div className="col-3">
              <DatePicker
                className='experience-date-picker-box'
                placeholder="End Date"
                name="end_date"
                value={this.state.end_date}
                onChange={(e) => { this.handleDateChange('end_date', e) }}
              />
            </div>
            <div className="col-4">
              <Button className='btn-added-right' onClick={() => { this.downloadReport() }}>
                Download Report
              </Button>
              <Button className='btn-added-right' onClick={() => { this.filterUserData() }}>
                View Data
              </Button>
            </div>
          </div> */}
          <div className="row">
            <div className="col-4">
              <DatePicker
                className='experience-date-picker-box'
                placeholder="Start Date"
                required
                name="start_date"
                value={this.state.start_date}
                onChange={(e) => { this.handleDateChange('start_date', e) }}
              />
            </div>
            <div className="col-4">
              <DatePicker
                className='experience-date-picker-box'
                placeholder="End Date"
                name="end_date"
                value={this.state.end_date}
                onChange={(e) => { this.handleDateChange('end_date', e) }}
              />
            </div>
            <div className="col-4">
              <Button className='btn-added-right' onClick={() => { this.downloadReport() }}>
                Download Report
              </Button>
              <Button className='btn-added-right' onClick={() => { this.filterUserData() }}>
                View Data
              </Button>
            </div>
          </div>
          <Input placeholder="Search" style={{ width: '300px', marginBottom: '20px' }} onChange={(e) => this.handleSearch(e.target.value)} />
          <Table
            columns={usersColumns}
            dataSource={resolution_data}
            onChange={(pagination, filters, sorter) => {
              this.handleSort(sorter.field);
            }}
            sortDirections={['ascend', 'descend']}
            sortOrder={this.state.sortOrder}
          />
          {/* <div className='container-tile'>
              Biddings
            </div>
            <div className='container-tile'>
              Customers
            </div>
            <div className='container-tile'>
              Providers
            </div> */}
        </div>
      </div>
    </div >
  );
}
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  }
}

export default connect(mapStateToProps)(Resolutions);
